import { RentalManagerUserInfoV2WebApiHandler_get_queryOptions } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';
import { getClient } from '@zg-rentals/ts-client-http-client';
import { createAuthPredicates } from '@zg-rentals/auth-comet/mfa';

const httpClient = getClient().extend({ prefixUrl: process.env.NEXT_PUBLIC_RENTAL_MANAGER_PREFIX_URL });

export type User = RentalManagerAuthCheckUserInfoWebApiDto;

export const { hasInitiatedAuth, hasAuth } = createAuthPredicates<User>((user) => ({
  ...user,
  isLoggedIn: user.loggedIn,
}));

export const Auth = defineAuthProvider({
  queryOptions: () => RentalManagerUserInfoV2WebApiHandler_get_queryOptions({}, { httpClient }),
  isAuthorized: hasInitiatedAuth,
});

export const { useAuth } = Auth;
